export function activeThreadContext(state) {
  const thread = state.aiAnalytics.activeThread;
  return { threadId: thread?.id, title: thread?.title };
}

export function chartContext(state, chartId) {
  const { savedCharts, selectedChart } = state.aiAnalytics;
  const chart = savedCharts.find(c => c.id === chartId) || (selectedChart?.id === chartId ? selectedChart : null);
  return { chartId, title: chart?.title };
}

export function resumedOpTitle(state, operation) {
  const { threads, savedCharts } = state.aiAnalytics;
  if (operation.chartId) {
    return savedCharts.find(chart => chart.id === operation.chartId)?.title;
  }
  return threads.find(thread => thread.id === operation.threadId)?.title;
}
